/**
 * De stijlen die meer dan één tabblad van het beheerpaneel gebruikt.
 *
 * Een tabblad spreidt dit uit in zijn eigen `styles` en zet daar achter wat
 * alleen dat tabblad nodig heeft: `const styles = { ...basis, ...eigen }`.
 */
import { kleur } from '../../theme/tokens';
import { gedeeld } from '../../theme/stijlen';

export const basis = {
  ...gedeeld,
  card: { background: 'white', padding: '24px', borderRadius: '12px', border: '1px solid black' },
  // knoppen
  addBtn: { padding: '8px 16px', background: kleur.accent, color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' },
  saveBtn: { padding: '8px 16px', background: kleur.accent, color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' },
  deleteBtn: { background: 'none', border: 'none', cursor: 'pointer', color: kleur.rood },
  formButtons: { display: 'flex', gap: '8px', marginTop: '10px' },
  // formulieren
  input: { width: '100%', padding: '10px', border: `1px solid ${kleur.lijnZacht}`, borderRadius: '6px', fontSize: '14px', marginBottom: '10px', boxSizing: 'border-box' },
  label: { display: 'block', fontWeight: 'bold', marginBottom: '4px', marginTop: '12px', fontSize: '14px' },
  row: { display: 'flex', gap: '10px', marginBottom: '10px' },
  checkboxLabel: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px' },
  editForm: { maxHeight: '80vh', overflowY: 'auto' },
  // lijsten en tekst
  listItemActive: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderRadius: '8px', marginBottom: '8px', cursor: 'pointer', background: kleur.accentLichter, border: `2px solid ${kleur.accent}` },
  beschrijving: { color: kleur.stil, marginBottom: '16px' },
  badge: { background: kleur.accent, color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '11px' },
  infoGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '20px', padding: '16px', background: kleur.vlak, borderRadius: '8px' },
  bronInfo: { padding: '8px', background: kleur.vlak, borderRadius: '4px', marginBottom: '12px', fontSize: '14px' },
};
